import { DEFAULT_FONT_COLOR } from '@messenger/consts'
import { EDITOR_FLOOR_CHARACTER_SEED } from '@messenger/lotus'
import { nonEmptyString as str } from './nonEmptyString'

export type EditorTextBoxSwatch = { hex: string; name: string }

export const EDITOR_COLOR_PALETTE: readonly EditorTextBoxSwatch[] = [
  { hex: '#BFEDD2', name: 'Light Green' },
  { hex: '#FBEEB8', name: 'Light Yellow' },
  { hex: '#F8CAC6', name: 'Light Red' },
  { hex: '#ECCAFA', name: 'Light Purple' },
  { hex: '#C2E0F4', name: 'Light Blue' },
  { hex: '#2DC26B', name: 'Green' },
  { hex: '#F1C40F', name: 'Yellow' },
  { hex: '#E03E2D', name: 'Red' },
  { hex: '#B96AD9', name: 'Purple' },
  { hex: '#3598DB', name: 'Blue' },
  { hex: '#169179', name: 'Dark Turquoise' },
  { hex: '#E67E23', name: 'Orange' },
  { hex: '#BA372A', name: 'Dark Red' },
  { hex: '#843FA1', name: 'Dark Purple' },
  { hex: '#236FA1', name: 'Dark Blue' },
  { hex: '#ECF0F1', name: 'Light Gray' },
  { hex: '#CED4D9', name: 'Medium Gray' },
  { hex: '#95A5A6', name: 'Gray' },
  { hex: '#7E8C8D', name: 'Dark Gray' },
  { hex: '#34495E', name: 'Navy Blue' },
  { hex: DEFAULT_FONT_COLOR, name: 'Black' },
  { hex: '#ffffff', name: 'White' },
]

export type EditorTextBoxThemeColors = {
  main?: string
  accent1?: string
  accent2?: string
}

type ThemeRecord = Record<string, unknown>

export const toEditorTextBoxThemeColors = (
  theme: ThemeRecord | null | undefined,
): EditorTextBoxThemeColors | undefined => {
  if (!theme) return undefined
  const colors: EditorTextBoxThemeColors = {}
  const main = str(theme.font_color)
  if (main) colors.main = main
  const accent1 = str(theme.font_color_accent1)
  if (accent1) colors.accent1 = accent1
  const accent2 = str(theme.font_color_accent2)
  if (accent2) colors.accent2 = accent2
  return Object.keys(colors).length > 0 ? colors : undefined
}

export const themeSwatches = (
  colors: EditorTextBoxThemeColors | undefined,
): EditorTextBoxSwatch[] => {
  if (!colors) return []
  const rows: EditorTextBoxSwatch[] = []
  if (colors.main) rows.push({ hex: colors.main, name: 'Theme color' })
  if (colors.accent1) rows.push({ hex: colors.accent1, name: 'Accent 1' })
  if (colors.accent2) rows.push({ hex: colors.accent2, name: 'Accent 2' })
  return rows
}

export const removeColorTarget = (
  colors: EditorTextBoxThemeColors | undefined,
): string => colors?.main ?? EDITOR_FLOOR_CHARACTER_SEED.color
